import { useEffect, useState } from 'react';

function Relatorios({ token, sair }) {
  const [registros, setRegistros] = useState([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    carregarRegistros();
  }, []);

  async function carregarRegistros() {
    try {
      const resposta = await fetch('https://ponto.rhfenix.com.br/api/registros-ponto', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (resposta.status === 401) {
        sair();
        return;
      }

      const dados = await resposta.json();

      if (dados.sucesso) {
        setRegistros(dados.registros);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCarregando(false);
    }
  }

  function formatarTipo(tipo) {
    const tipos = {
      entrada: 'Entrada',
      saida_almoco: 'Saída Almoço',
      retorno_almoco: 'Retorno Almoço',
      saida: 'Saída',
      extra: 'Extra'
    };

    return tipos[tipo] || tipo;
  }

  return (
    <div className="content">

      <div className="page-header">
        <h2>Histórico de Ponto</h2>

        <button
          className="primary"
          onClick={carregarRegistros}
        >
          Atualizar
        </button>
      </div>

      <div className="table-container">

        {carregando ? (
          <p>Carregando registros...</p>
        ) : (

          <table>
            <thead>
              <tr>
                <th>Colaborador</th>
                <th>CPF</th>
                <th>Matrícula</th>
                <th>Tipo</th>
                <th>Confiança</th>
                <th>Data/Hora</th>
              </tr>
            </thead>

            <tbody>
              {registros.map((registro) => (
                <tr key={registro.id}>
                  <td>{registro.nome}</td>
                  <td>{registro.cpf || '-'}</td>
                  <td>{registro.matricula || '-'}</td>
                  <td>{formatarTipo(registro.tipo)}</td>
                  <td>
                    {registro.confianca
                      ? Number(registro.confianca).toFixed(2)
                      : '-'}
                  </td>
                  <td>
                    {registro.created_at
                      ? new Date(registro.created_at).toLocaleString('pt-BR')
                      : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        )}

      </div>

    </div>
  );
}

export default Relatorios;
